
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vivosun-check-in-events",
      function () {
        return require("private-next-pages/vivosun-check-in-events.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vivosun-check-in-events"])
      });
    }
  